module.exports = __webpack_public_path__ + "img/ymap_fake.e358253b.jpg";